import { pickBy, compose } from "lodash/fp";
import { GOHONZON_TYPE } from "../../../contants";
import {
  GOHONZON_OMAMORI_FIELDS,
  GOHONZON_SUBMISSION,
} from "../../../contants/formFields";
import { validNumber } from "../../../utils";
import { isEmptyObj } from "../../../utils/helper";
import {
  GOHONZON_FORM_TYPE,
  returnGohonzonQuestions,
} from "../../../contants/gohonzon";

const INPUT_TYPE_NUMBER = [
  GOHONZON_OMAMORI_FIELDS.DAYS_AWAY_FROM_HOME,
  GOHONZON_OMAMORI_FIELDS.REGULAR_PRACTICE,
  GOHONZON_OMAMORI_FIELDS.GOHONZON_MEMBERSHIP,
];

export const getErrorInfo = (message = null) => ({
  message: message ?? "Something Went Wrong",
  severity: "error",
});

export const getSuccessInfo = (message = "") => ({
  message: message || "Successfully Done",
  severity: "success",
});

export const formValidate = (
  chapterIds,
  values,
  gohonzonType,
  { isChapterSi, isDistrictSi }
) => {
  console.log("Ids:", chapterIds);

  if (gohonzonType === GOHONZON_TYPE.OKATAKI_GOHONZON && isChapterSi) {
    console.log("valuies:", values);
    if (!values[GOHONZON_SUBMISSION.DURATION_OF_PRACTICE]) {
      return "Please enter Duration of Practice field";
    }
    if (!values[GOHONZON_SUBMISSION.REGULAR_GONGYO_DAIMOKU]) {
      return "Please enter Regular Gongyo Daimoku field";
    }
    if (!values[GOHONZON_SUBMISSION.PERMISSION_TO_RECEIVE]) {
      return "Please enter Permission To Receive field";
    }
    if (!values[GOHONZON_SUBMISSION.PLACE_OF_ENSHRINED]) {
      return "Please enter Place of Enshrined field";
    }
    if (chapterIds.length === 0) {
      return "Please select Home Visited by";
    }
  } else if (
    gohonzonType === GOHONZON_TYPE.OMAMORI_GOHONZON &&
    isDistrictSi &&
    isChapterSi
  ) {
    if (
      !values[GOHONZON_OMAMORI_FIELDS.COMPANY_NAME] ||
      !values[GOHONZON_OMAMORI_FIELDS.COMPANY_NAME].length
    ) {
      return "Please enter Company name field";
    }
    if (!values[GOHONZON_OMAMORI_FIELDS.JOB_POSITION]) {
      return "Please enter Job position field";
    }
    if (!values[GOHONZON_OMAMORI_FIELDS.NATURE_OF_WORK]) {
      return "Please enter Nature of work field";
    }
    if (!validNumber(values[GOHONZON_OMAMORI_FIELDS.DAYS_AWAY_FROM_HOME])) {
      return "Please enter Days away from home field";
    }
    if (!validNumber(values[GOHONZON_OMAMORI_FIELDS.REGULAR_PRACTICE])) {
      return "Please enter Regular Practice field";
    }
    if (!validNumber(values[GOHONZON_OMAMORI_FIELDS.GOHONZON_MEMBERSHIP])) {
      return "Please enter Gohonzon membership field";
    }
    if (!values[GOHONZON_OMAMORI_FIELDS.ACTIVE_PARTICIPATION]) {
      return "Please enter Active participation field";
    }
    if (chapterIds.length === 0) {
      return "Please select Home Visited by";
    }
  }

  return "";
};

const getAnswer = (question, answer) => {
  if (question.answerType === "boolean") return !!answer;
  return answer || "";
};

export const prepareReturnOrReplaceBody = (formValues) => {
  const getAllBooleanField = (trueValues) => {
    return returnGohonzonQuestions.reduce(
      (acc, curr) => [
        ...acc,
        {
          questionId: Number(curr.questionId),
          answer: getAnswer(curr, trueValues[curr.name]),
        },
      ],
      []
    );
  };

  const getReplaceReasonPayload = () => {
    return {
      replacementReason: formValues.replacementReason,
      isReplacement: true,
    };
  };

  const getReturnInputsPayload = (result) => {
    return {
      returnReasons: result,
      isReplacement: false,
    };
  };

  return formValues.replaceCheck
    ? getReplaceReasonPayload()
    : compose(
        getReturnInputsPayload,
        getAllBooleanField
        // pickBy(Boolean)
      )(formValues);
};

const returnInputSelected = (inputs) => inputs.some((input) => input.answer);

export const validateReturnOrReplaceValues = (payload, isReplace) => {
  if (isReplace && !payload.replacementReason?.length) {
    return "Please Fill Replace Reason";
  }
  if (!isReplace && !returnInputSelected(payload.returnReasons)) {
    return "Please Select Return Reason";
  }
  return "";
};

export const getReturnHandoverFields = (memberInfo) => {
  console.log("member:", memberInfo);

  if (
    !isEmptyObj(memberInfo) &&
    (memberInfo.replacementReason || memberInfo.returnReasons?.length)
  ) {
    if (memberInfo.formType === GOHONZON_FORM_TYPE.REPLACEMENT) {
      return {
        replacementReason: memberInfo.replacementReason ?? "",
        replaceCheck: true,
      };
    }
    if (memberInfo.formType === GOHONZON_FORM_TYPE.RETURN) {
      return memberInfo.returnReasons.reduce(
        (acc, curr) => {
          const key = `radio-${curr.questionId}`;

          return Object.assign(acc, { [key]: curr.answer });
        },
        {
          replaceCheck: false,
        }
      );
    }
  }
  return {};
};

export const getOkatakiAnswerFields = (
  memberInfo,
  isChapterSi,
  isInterviewRegionSi
) => {
  if (
    (!isEmptyObj(memberInfo) && memberInfo.memberAnswers?.length) ||
    memberInfo.chapterAnswers?.length
  ) {
    console.log("Question :", memberInfo.memberAnswers);

    if (isChapterSi || isInterviewRegionSi) {
      return memberInfo.memberAnswers.reduce((acc, curr) => {
        console.log("Question :", curr.questionId);
        const key = `radio-${curr.questionId}`;
        return Object.assign(acc, { [key]: curr.answer });
      });
    }
    if (isInterviewRegionSi) {
      return memberInfo.chapterAnswers.reduce((acc, curr) => {
        const key = `radio-${curr.questionId}`;
        return Object.assign(acc, { [key]: curr.answer });
      });
    }
  }
  return {};
};

export const getFormattedOptions = (opts) => {
  if (!isEmptyObj(opts)) {
    return Object.keys(opts).map((key) => ({
      key: opts[key],
      value: Number(key),
    }));
  }
  return [];
};

export const getTitle = (gohonzonType, isReturn) => {
  if (isReturn) {
    return "Return/Replacement Application Form";
  }
  if (gohonzonType === GOHONZON_TYPE.OMAMORI_GOHONZON) {
    return "Omamori Gohonzon Application Form";
  }
  if (gohonzonType === GOHONZON_TYPE.SPECIAL_GOHONZON) {
    return "Special Gohonzon Application Form";
  }
  return "Gohonzon Application Form";
};

export const getFieldsWithValue = (formFields, values) => {
  const getValue = (key, value) =>
    INPUT_TYPE_NUMBER.includes(key) ? Number(value) : value;

  return Object.values(formFields).reduce(
    (acc, curr) =>
      Object.assign(acc, {
        [curr]: values[curr] ? getValue(curr, values[curr]) : "",
      }),
    {}
  );
};

export const okatakiInterviewByRegionValidation = (
  regionIds,
  values,
  gohonzonType,
  { isInterviewRegionSi }
) => {
  const acceptByAllCommittee = values.approvedByAllCommitteeMembers;

  if (gohonzonType === GOHONZON_TYPE.OKATAKI_GOHONZON && isInterviewRegionSi) {
    console.log("valuies:", values);
    if (!values[GOHONZON_SUBMISSION.DURATION_OF_PRACTICE]) {
      return "Please enter Duration of Practice field";
    }
    if (!values[GOHONZON_SUBMISSION.REGULAR_GONGYO_DAIMOKU]) {
      return "Please enter Regular Gongyo Daimoku field";
    }

    if (!values[GOHONZON_SUBMISSION.PERMISSION_TO_RECEIVE]) {
      return "Please enter Permission To Receive field";
    }

    if (!values[GOHONZON_SUBMISSION.PLACE_OF_ENSHRINED]) {
      return "Please enter Place of Enshrined field";
    }
    if (!regionIds || !regionIds.length || !acceptByAllCommittee) {
      return "Please fill required fields";
    }
  }

  return "";
};

/// new payload for Return/Replace gohonzon

export const prepareReturnOrReplacePayload = (formValues) => {
  const getAllBooleanField = () => {
    return returnGohonzonQuestions.reduce((acc, curr) => {
      if (curr.name in formValues) {
        return [
          ...acc,
          {
            questionId: Number(curr.questionId),
            answer: formValues[curr.name],
          },
        ];
      }
      return acc;
    }, []);
  };

  const getReplaceReasonPayload = () => {
    return {
      replacementReason: formValues.replacementReason,
      isReplacement: true,
    };
  };

  const getReturnInputsPayload = (result) => {
    return {
      returnReasons: result,
      isReplacement: false,
    };
  };

  return formValues.replaceCheck
    ? getReplaceReasonPayload()
    : compose(
        getReturnInputsPayload,
        getAllBooleanField,
        pickBy(Boolean)
      )(formValues);
};
